import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-empty-feed',
  templateUrl: './empty-feed.component.html',
  styleUrls: ['./empty-feed.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

/**
 * Empty feed component
 */
export class EmptyFeedComponent {
  @Input() icon?: string;
  @Input() header?: string;
  @Input() text?: string;
}
